import Cookies from 'js-cookie'

export enum Params {
  deal = 'deal',
  promo = 'promo',
  gclid = 'gclid',
  fbclid = 'fbclid',
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  utm_term = 'utm_term',
  utm_content = 'utm_content',
}

const getCookieDomain = (): string | undefined => {
  if (typeof window === 'undefined') return undefined
  const host = window.location.hostname
  if (!host || host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return undefined
  }
  const parts = host.split('.')
  if (parts.length < 2) return undefined
  return `.${parts.slice(-2).join('.')}`
}

export const captureQueryParams = (searchParams) => {
  Object.keys(Params).forEach((param) => {
    const paramValue = searchParams.get(param)
    if (paramValue) {
      localStorage.setItem(Params[param], paramValue)
    }
  })

  // When a fresh ad click lands here, immediately seed _fbc with Meta's
  // documented format. The fbq pixel will overwrite this if/when it loads,
  // but we no longer depend on it — every subsequent event reads a valid _fbc.
  const fbclid = searchParams.get(Params.fbclid)
  if (fbclid) {
    Cookies.set('_fbc', `fb.1.${Date.now()}.${fbclid}`, {
      domain: getCookieDomain(),
      expires: 90,
      sameSite: 'lax',
    })
  }
}
